import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import logoDefault from '../assets/libben-smart.png';
import { handleTalkToSpecialist } from '../utils/webchat';
import './Navbar.css';

const APP_URL = process.env.REACT_APP_APP_URL || 'https://app.libbenagents.com';

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const toggleLang = () => i18n.changeLanguage(i18n.language === 'pt' ? 'en' : 'pt');

  // Âncoras só funcionam na Home; fora dela usamos o link de página (/precos).
  const homeLinks = [
    { key: 'features', href: '#features' },
    { key: 'integrations', href: '#integrations' },
    { key: 'pricing', href: '#pricing' },
    { key: 'faq', href: '#faq' },
  ];

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <a href="/" className="navbar-logo">
          <img src={logoDefault} alt="Libben Agents" className="navbar-logo-img" />
        </a>

        <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          {isHome ? (
            homeLinks.map(({ key, href }) => (
              <li key={key}>
                <a href={href} onClick={closeMenu}>
                  {t(`nav.${key}`)}
                </a>
              </li>
            ))
          ) : (
            <li>
              <a href="/precos" onClick={closeMenu} className={location.pathname === '/precos' ? 'active' : ''}>
                {t('nav.pricing')}
              </a>
            </li>
          )}
          <li>
            <a
              href="/saude"
              onClick={closeMenu}
              className={location.pathname === '/saude' ? 'active' : ''}
            >
              {t('nav.health', { defaultValue: 'Saúde' })}
            </a>
          </li>
          <li>
            <a href="/agentes" onClick={closeMenu} className={location.pathname.startsWith('/agentes') ? 'active' : ''}>
              {t('nav.agents', { defaultValue: 'Agentes' })}
            </a>
          </li>
        </ul>

        <div className="navbar-actions">
          <button className="btn-lang" onClick={toggleLang} aria-label="Trocar idioma">
            {i18n.language === 'pt' ? 'EN' : 'PT'}
          </button>
          <a href={`${APP_URL}/login`} className="btn-ghost">{t('nav.login')}</a>
          <button type="button" onClick={handleTalkToSpecialist} className="btn-primary">{t('nav.signup')}</button>
          <button className="btn-menu" onClick={() => setMenuOpen(!menuOpen)} aria-label="Abrir menu" aria-expanded={menuOpen}>
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>
    </nav>
  );
}
